import { setHours, setMinutes, setSeconds, setMilliseconds } from "date-fns";

export const convertToBrowserDateAsSeconds = (utcDateAsEpoch) => {
  const date = new Date(utcDateAsEpoch);
  const browserDate = date.getTime() - date.getTimezoneOffset() * 60000;
  return browserDate;
};

export const convertToBrowserDateAsMilliseconds = (utcDateAsEpoch) => {
  const browserDateInSeconds = convertToBrowserDateAsSeconds(utcDateAsEpoch);
  return browserDateInSeconds * 1000; 
};


export const convertToUTCDateFromSeconds = (browserDateAsSeconds) => {
  const browserDateAsMilliseconds = browserDateAsSeconds * 1000; 
  const date = new Date(browserDateAsMilliseconds);
  const utcDate = date.getTime() + date.getTimezoneOffset() * 60000;
  return utcDate;
};

export const convertToUTCDateFromMilliseconds = (browserDateAsMilliseconds) => {
  const date = new Date(browserDateAsMilliseconds);
  const utcDate = date.getTime() + date.getTimezoneOffset() * 60000;
  return utcDate;
};

export const convertToBrowserDateAsDate = (utcDateAsEpoch) => {
  const browserDateAsSeconds = convertToBrowserDateAsSeconds(utcDateAsEpoch);
  const browserDate = new Date(browserDateAsSeconds);
  // console.log("🚀 ~ convertToBrowserDateAsDate ~ browserDate:", browserDate)
  return browserDate;
};


export function convertTimestampToUTCAndLocalTime(timestamp) {
  // Convert milliseconds to Date object
  const date = new Date(timestamp);

  // Extract the UTC date and time components
  const utcDate = date.toISOString().split('T')[0]; // Get the UTC date part
  const utcTime = date.toISOString().split('T')[1].split('.')[0]; // Get the UTC time part

  // Extract the local date and time components
  const localDate = date.toLocaleDateString(); // Get the local date part
  const localTime = date.toLocaleTimeString(); // Get the local time part

  return {
    utcDate,
    utcTime,
    localDate,
    localTime,
  };
}



export const formatDateToUTCString = (date) => {
  if (!date) return null;  // Handle null or undefined dates

  // Set the time to noon (12:00 PM) to avoid timezone shifts
  const adjustedDate = setHours(date, 12);
  const finalizedDate = setMinutes(setSeconds(setMilliseconds(adjustedDate, 0), 0), 0);

  // Return the ISO string (UTC)
  return finalizedDate.toISOString();
};